export default function BrandLogo({ size = "md", showSubtitle = true, className = "" }) {
    const sizes = {
        sm: { hex: 28, font: "text-[11px]", name: "text-sm", sub: "text-[8px]" },
        md: { hex: 36, font: "text-sm", name: "text-base", sub: "text-[9px]" },
        lg: { hex: 64, font: "text-2xl", name: "text-3xl", sub: "text-[11px]" },
    };
    const s = sizes[size] || sizes.md;
    return (
        <div className={`flex items-center gap-3 ${className}`}>
            <svg
                width={s.hex}
                height={s.hex}
                viewBox="0 0 100 100"
                aria-hidden="true"
                className="shrink-0"
            >
                {/* Main hexagon — navy */}
                <polygon
                    points="50,4 88,26 88,74 50,96 12,74 12,26"
                    fill="#1a2e4a"
                />
                {/* Subtle gold sliver bottom-right */}
                <polygon
                    points="88,74 88,26 50,96"
                    fill="#c8a84b"
                    opacity="0.95"
                />
                {/* Light gold sliver top */}
                <polygon
                    points="12,26 50,4 88,26"
                    fill="#e8c96a"
                    opacity="0.18"
                />
                {/* AB monogram */}
                <text
                    x="50"
                    y="62"
                    textAnchor="middle"
                    fill="#ffffff"
                    fontFamily="Arial, sans-serif"
                    fontWeight="800"
                    fontSize="34"
                    letterSpacing="-1.5"
                >
                    AB
                </text>
            </svg>
            <div className="min-w-0">
                <div
                    className={`font-heading font-extrabold ${s.name} leading-none tracking-[0.08em] uppercase text-ink`}
                >
                    AB Promotion
                </div>
                {showSubtitle && (
                    <div
                        className={`uppercase tracking-[0.22em] text-accent mt-1.5 ${s.sub} font-medium`}
                    >
                        Immobilier · Construction
                    </div>
                )}
            </div>
        </div>
    );
}
